"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("util");

var abi_coder_1 = require("../abi-coder");

var contract_entry_1 = require("./contract-entry");

var ContractEventEntry = /*#__PURE__*/function (_contract_entry_1$Con) {
  _inherits(ContractEventEntry, _contract_entry_1$Con);

  function ContractEventEntry(entry) {
    var _this;

    _classCallCheck(this, ContractEventEntry);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContractEventEntry).call(this, entry));
    _this.signature = abi_coder_1.abiCoder.encodeEventSignature(abi_coder_1.abiCoder.abiMethodToString(entry));
    return _this;
  }

  _createClass(ContractEventEntry, [{
    key: "getEventTopics",
    value: function getEventTopics() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var topics = [];

      if (!this.entry.anonymous && this.signature) {
        topics.push(this.signature);
      }

      var indexedTopics = (this.entry.inputs || []).filter(function (input) {
        return input.indexed === true;
      }).map(function (input) {
        var value = filter[input.name];

        if (!value) {
          return null;
        } // TODO: https://github.com/ethereum/web3.js/issues/344
        // TODO: deal properly with components


        if (util_1.isArray(value)) {
          return value.map(function (v) {
            return abi_coder_1.abiCoder.encodeParameter(input.type, v);
          });
        } else {
          return abi_coder_1.abiCoder.encodeParameter(input.type, value);
        }
      });
      return [].concat(topics, _toConsumableArray(indexedTopics));
    }
  }, {
    key: "decodeEvent",
    value: function decodeEvent(log) {
      var _log$data = log.data,
          data = _log$data === void 0 ? '' : _log$data,
          _log$topics = log.topics,
          topics = _log$topics === void 0 ? [] : _log$topics,
          formattedLog = _objectWithoutProperties(log, ["data", "topics"]);

      var _this$entry = this.entry,
          anonymous = _this$entry.anonymous,
          _this$entry$inputs = _this$entry.inputs,
          inputs = _this$entry$inputs === void 0 ? [] : _this$entry$inputs,
          _this$entry$name = _this$entry.name,
          name = _this$entry$name === void 0 ? '' : _this$entry$name;
      var argTopics = anonymous ? topics : topics.slice(1);
      var returnValues = abi_coder_1.abiCoder.decodeLog(inputs, data, argTopics);
      delete returnValues.__length__;
      return _objectSpread({}, formattedLog, {
        event: name,
        returnValues: returnValues,
        signature: anonymous || !topics[0] ? null : topics[0],
        raw: {
          data: data,
          topics: topics
        }
      });
    }
  }]);

  return ContractEventEntry;
}(contract_entry_1.ContractEntry);

exports.ContractEventEntry = ContractEventEntry;